// extracted by mini-css-extract-plugin
export default {"preserve_whitespace":"cQupgEzgxOaDFOGgL5Cq"};